module.exports = __webpack_public_path__ + "static/media/AppDownLoadImage04.4cae49f8.png";